'use client'

import { Spinner } from '@src/components/Spinner/Spinner'

export const LoadingCartPageContent = () => {
  return (
    <div className="flex h-[350px] items-center justify-center bg-bodi-gray-pearl lg:h-[640px]">
      <Spinner size="large" className=" size-24 fill-bodi-green-bright-500" />
    </div>
  )
}
